@let data = icon();
<div class="container" [ngClass]="data.combinedClasses">
  <aiwyn-icon [name]="data.name" [namespace]="data.namespace" [height]="16" [width]="16"></aiwyn-icon>
</div>
